/**
 * Color helpers shared by Adsum drawer + floating orb badge.
 * 0 → 40   eases RED → AMBER
 * 40 → 70  eases AMBER → MINT
 * 70 → 100 saturates MINT
 */
const RED = "#FF5470";
const AMBER = "#F4B860";
const MINT = "#00F5D4";

function hexToRgb(hex) {
    const n = parseInt(hex.slice(1), 16);
    return [(n >> 16) & 0xff, (n >> 8) & 0xff, n & 0xff];
}

function rgbToHex(r, g, b) {
    return (
        "#" +
        [r, g, b]
            .map((v) => Math.round(v).toString(16).padStart(2, "0"))
            .join("")
    );
}

function lerpHex(a, b, t) {
    const [r1, g1, b1] = hexToRgb(a);
    const [r2, g2, b2] = hexToRgb(b);
    const tt = Math.max(0, Math.min(1, t));
    return rgbToHex(
        r1 + (r2 - r1) * tt,
        g1 + (g2 - g1) * tt,
        b1 + (b2 - b1) * tt
    );
}

export function scoreColor(score) {
    if (score <= 40) return lerpHex(RED, AMBER, score / 40);
    if (score <= 70) return lerpHex(AMBER, MINT, (score - 40) / 30);
    return MINT;
}

export const ADSUM_COLORS = { RED, AMBER, MINT };
